Vue.component("stateprofileitem", {
  props: {
    type: {
      type: String
    },
    chosenState: {},
    dataformat: {},
    hastable: {},
    multiple: {},
    title: { default: false, required: false },
    preset: { default: false, required: false },
    showstaterank: { default: false, required: false },
    rankorder: { default: "desc" },
    datafield: { default: false, required: false },
    showMap: { default: false, required: false },
    fielddata: { default: false, required: false },
    thiskey: { default: false, required: false },
    districtmap: { default: false, required: false },
    districtdata: {},
    multiyear: { default: false, required: false },
    piechart: { default: false, required: false },
    columnchart: { default: false, required: false },
    multicolumn: { default: false, required: false },
    startyear: { required: false, default: 2009 },
    endyear: { required: false, default: 2023 }
  },
  data() {
    return {
      isloaded: false,
      sortedData: false,
      featured: false,
      forecast: false,
      data: false,
      staterank: false,
      allstatedata: [],
      showTable: false,
      isLoadingTable: false,
      updatesearch: false,
      multiyearData: false,
      activeYear: false,
      animating: false,
      fielddataraw: false,
      haslegend: false,
      /* MAP DATA POINTS, MIGHT BE MOVED TO COMPUTED, OR UPDATED ELSEWHERE */
      dataset: "",
      dataKey: "data_field_id",
      updates: 0,

      districtmapdata: false
    };
  },
  computed: {
    allstatedatasorted() {
      if (!this.allstatedata || this.allstatedata.length == 0) {
        return false;
      }
      let $this = this;
      let newobj = this.allstatedata.sort(function (a, b) {
        let aval = a.value;
        let bval = b.value;

        // ORDER IS DESCENDING
        if ($this.rankorder == "asc") {
          if (aval > bval) {
            return 1;
          }
          if (bval > aval) {
            return -1;
          }
          return 0;
        } else {
          if (aval > bval) {
            return -1;
          }
          if (bval > aval) {
            return 1;
          }
          return 0;
        }
      });
      return newobj;
    },
    thisstaterank() {
      if (!this.allstatedatasorted) {
        return false;
      }
      let index = this.allstatedatasorted.findIndex((d) => d.state == this.chosenState.abbr);
      return index + 1;
    },
    abbrToState() {
      return slideAbbrToState();
    },
    tableRows() {
      if (!this.allstatedatasorted) {
        return {};
      }
      let newobj = {};
      for (let i = 0; i < this.allstatedatasorted.length; i++) {
        newobj[this.abbrToState[this.allstatedatasorted[i].state].toUpperCase()] = {
          STATE: this.abbrToState[this.allstatedatasorted[i].state].toUpperCase(),
          [this.datafield * 1]: this.allstatedatasorted[i].value
        };
      }
      return newobj;
    },
    search() {
      if (!this.datafield || !this.fielddata) {
        return {};
      }
      let df = this.datafield;

      if (this.datafield[0] == "c") {
        df = this.datafield.slice(1);
      }
      let fieldinfo = this.fielddata[this.datafield];
      let newobj = {
        selected: {
          filters: {
            data_field_id: [fieldinfo]
          }
        }
      };
      return newobj;
    },
    tableToggleText() {
      if (this.showTable) {
        return "Hide Table";
      }
      return "Show Table";
    },
    thisstatename() {
      return this.chosenState.name;
    },
    booleanData() {
      if (!this.sortedData) {
        return false;
      }
      if (this.sortedData == "nodata") {
        return "nodata";
      }
      let d = {};
      for (i = 0; i < this.sortedData.length; i++) {
        let val = +this.sortedData[i].data_value;
        let nces = this.sortedData[i].nces_id;
        if (val > 0) {
          d[nces] = 1;
        } else {
          d[nces] = 0;
        }
      }
      return d;
    },
    piedata() {
      if (!this.booleanData || this.booleanData == "nodata") {
        return false;
      }

      let zero = Object.values(this.booleanData).filter((val) => val == 0);
      let one = Object.values(this.booleanData).filter((val) => val == 1);
      let sum = zero.length + one.length;
      let zerop = (zero.length / sum) * 100;
      let onep = (one.length / sum) * 100;

      return { yes: onep, no: zerop };
    },
    columndata() {
      if (!this.multiyearData) {
        return false;
      }
      // * DOING FOR BOOLEAN
      let a = [];
      for (const y in this.multiyearData) {
        let zero = Object.values(this.multiyearData[y]).filter((val) => +val.data_value == 0);
        let one = Object.values(this.multiyearData[y]).filter((val) => +val.data_value > 0);
        let sum = zero.length + one.length;
        let zerop = (zero.length / sum) * 100;
        let onep = (one.length / sum) * 100;
        let obj = { label: y, yes: onep, no: zerop };
        a.push(obj);
      }
      a.sort(function (a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
      return a;
    },
    labels() {
      if (!this.columndata) {
        return false;
      }
      let a = [];
      for (const d of this.columndata) {
        a.push(d.label);
      }
      return a;
    },
    labelHTML() {
      if (!this.columndata) {
        return false;
      }
      // * THIS IS ONLY AVAILABLE AS YES/NO CURRENTLY
      let html = '<div class="multiyear-labels">';
      html +=
        '<div><div class="profile_key_display" style="background: rgba(0, 85, 162, 0.9)"></div><div>Has Librarian FTE</div></div>';
      html +=
        '<div><div class="profile_key_display" style="background: rgba(0, 85, 162, 0.1)"></div><div>Has No Librarian FTE</div></div>';

      html += "</div>";
      return html;
    }
  },
  watch: {
    chosenState(val) {
      if (val && !this.isloaded) {
        this.getData();
        //this.getDistrictData();
      }
    },
    isloaded(val) {
      if (val) {
        this.getData();
        //this.getDistrictData();
      }
    }
  },
  async created() {
    if (!this.chosenState) {
      return;
    }
    this.getData();
    //this.getDistrictData();
  },

  methods: {
    async getData() {
      let obj = new FormData();
      if (this.type == "districtmap") {
        obj.append("action", "slide_get_search_data");
        let params = {
          filters: {
            STATE: [this.chosenState.name],
            data_field_id: [this.datafield]
          },
          fields: {},
          tableRowKey: "nces_id"
        };
        if (this.multiyear) {
          let y = [];
          for (let i = this.startyear; i <= this.endyear; i++) {
            y.push(i + "-" + (i + 1 - 2000));
          }
          params.years = y;
        }
        obj.append("params", JSON.stringify(params));
      } else {
        obj.append("action", "slide_get_state_data");
        if (this.preset) {
          obj.append("preset", this.preset);
          if (this.datafield) {
            obj.append("datafield", +this.datafield);
          }
        }
        obj.append("state", this.chosenState.abbr);
      }

      let data = await axios.post(axios_ajax.ajaxurl, obj);

      if (this.type == "districtmap" && this.multiyear) {
        let o = {};
        for (let i = 0; i < data.data.length; i++) {
          if (!o[data.data[i].data_year]) {
            o[data.data[i].data_year] = [];
          }
          o[data.data[i].data_year].push(data.data[i]);
        }
        let endyearbig = this.endyear + "-" + (this.endyear + 1 - 2000);
        this.multiyearData = o;
        this.activeYear = endyearbig;
        this.sortedData = o[endyearbig];
        if (typeof this.sortedData == "undefined") {
          this.sortedData = "nodata";
        }
      } else {
        this.sortedData = data.data;
        const parseTime = d3.timeParse("%Y-%m-%d");
        if (this.multiple) {
          for (let i = 0; i < this.sortedData.length; i++) {
            for (let j = 0; j < this.sortedData[i].Data.length; j++) {
              this.sortedData[i].Data[j].date = parseTime(this.sortedData[i].Data[j].date);
            }
          }
        } else {
          for (let i = 0; i < this.sortedData.length; i++) {
            this.sortedData[i].date = parseTime(this.sortedData[i].date);
          }
        }
      }

      if (this.showstaterank && this.datafield) {
        let obj = new FormData();
        obj.append("action", "slide_get_state_data");
        obj.append("preset", "allstates");
        obj.append("datafield", this.datafield);
        let data = await axios.post(axios_ajax.ajaxurl, obj);
        console.log(this.datafield);
        console.log({ data });
        for (let i = 0; i < data.data.length; i++) {
          let v = parseFloat(data.data[i].value.replace(/,/g, ""));
          let newobj = {
            state: data.data[i].state,
            value: v
          };
          let exists = this.allstatedata.findIndex((d) => d.state == newobj.state);
          if (exists == -1) {
            this.allstatedata.push(newobj);
          }
        }
        //this.allstatedata = data.data;
        this.updates++; // update the map
      }

      this.isloaded = true;
    },
    getDistrictData() {},

    toggleTable() {
      /*
            let t = document.getElementById('modal_' + this.thiskey);
            t.classList.add('active');
            return;
            */
      this.showTable = !this.showTable;
    },
    formatData(data) {
      return formatSlideData(data, this.dataformat);
    },
    async animate() {
      let $this = this;
      if (this.animating) {
        return;
      }
      this.animating = true;
      for (let i = this.startyear; i <= this.endyear; i++) {
        activeYear = i + "-" + (i + 1 - 2000);
        $this.sortedData = $this.multiyearData[activeYear];
        if (typeof this.sortedData == "undefined") {
          $this.sortedData = "nodata";
        }
        this.activeYear = activeYear;
        await this.wait(1000);
      }
      this.animating = false;
    },
    wait(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    }
  }
});
